export default "__VITE_ASSET__COrCp2t6__"